<template>
  <div
    class="app-font-icon"
    :class="`icon-${name} ${isClickable ? 'hand-pointer' : 'hand-default'}`"
    :style="{ fontSize: size, color: color }"
    v-bind="{ ...resetProps }"
  />
</template>

<script>
export default {
  name: "FIcon",

  props: {
    name: {
      default: null,
      type: String,
    },

    size: {
      type: String,
      default: "1.5rem",
    },

    color: {
      type: String,
      default: null,
    },

    count: {
      type: Number,
      default: null,
    },

    classes: {
      type: Array,
    },

    isClickable: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    resetProps() {
      return { ...this.$attrs };
    },

    getArrayByCount() {
      if (!this.count) return 0;

      const count = this.count + 1;
      return [...Array(count)];
    },
  },
};
</script>

<style src="./styles.scss" scoped lang="scss" />
